import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next/router';
import { useLazyLoadQuery } from 'react-relay';

import type { lookupUserQuery } from '@/__generated__/lookupUserQuery.graphql';
import Layout from '@/components/layout/Layout';
import { CancelContent } from '@/components/tax-refund/cancel/CancelContent';
import { lookupUser } from '@/graphql/query/lookup-user';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { COMMON_PATHS, CORPORATION_PATHS } from '@/lib/constants/paths';
import { cancelDataAtom } from '@/lib/stores/cancel-data';
import { zCurrency } from '@/lib/utils/zCurrency';

const CorporationCancelPage = () => {
  const router = useRouter();
  const data = useLazyLoadQuery<lookupUserQuery>(lookupUser, {}, {});
  const cancelData = useAtomValue(cancelDataAtom);

  // 환급 대상 법인 데이터가 없으면 결과 페이지로 이동
  if (!data?.bznavRefund?.user?.corps || data.bznavRefund.user.corps.length < 1) {
    router.push({ pathname: COMMON_PATHS.환급신청결과, query: { type: 'corps' } });
    return <></>;
  }

  // 환급 대상 법인 데이터 추출(여러 개일 경우 첫 번째 사용, 필요시 로직 수정)
  const item = data?.bznavRefund?.user?.corps.find((corpItem) => {
    return corpItem.refundId === cancelData?.refundId;
  });
  const name = item?.businessInfo?.hometaxBizName ?? '고객';
  const payAmount = zCurrency(item?.refundAmount, '', true, '0');
  const discountRate = item?.partnerInfo?.discountRate;

  return (
    <AuthGuard>
      <PageViewEventLogger pageName="corps-cancel" eventName="corps-cancel_defense">
        <Layout
          leftIcon={{
            icon: 'back',
            clickEvent: { name: 'corps-cancel_topnav_back' }
          }}
        >
          <CancelContent
            name={name}
            payAmount={payAmount}
            discountRate={discountRate}
            resultPath={COMMON_PATHS.환급신청결과}
            reasonPath={CORPORATION_PATHS.법인취소사유}
            supportBotLink={SUPPORT_BOT_LINK.default}
            titleSuffix=""
            businessType="corps"
          />
        </Layout>
      </PageViewEventLogger>
    </AuthGuard>
  );
};

export default CorporationCancelPage;
